import * as React from "react";
import type { SVGProps } from "react";

interface CornerProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Corner = ({ cancelled = false, ...props }: CornerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="nonzero">
      <path
        fill="#000"
        stroke="#FFF"
        strokeWidth={0.75}
        d="M10.063 1.937a7 7 0 0 1 .84.147l.983.259c1.012.275 1.696.374 2.675.374a7 7 0 0 0 2.155-.327c.515-.138.982-.089 1.365.09.429.2.756.562.909 1.034l.084 6.733a1.77 1.77 0 0 1-1.06 1.624c-1.486.635-2.525.88-3.453.88-1.028 0-1.72-.118-2.83-.48l-.933-.31a6 6 0 0 0-.74-.193 10.4 10.4 0 0 0-1.612-.113l-.532.008-.189 9.837c0 .316-.143.599-.368.787-.783.011-1.071-.071-1.244-.152L5.675 3c0-.291.094-.557.275-.753.162-.174.398-.301.727-.321q.359-.022.664-.034l.835-.025q1.148-.014 1.887.07Zm-.229 2.037c-.435-.05-1.024-.067-1.84-.052l-.217.005.003 5.69.06-.002q1.268-.036 2.039.053l.211.027c.516.078.892.17 1.47.358l.82.274c.861.28 1.365.374 2.181.374q.977-.002 2.333-.576l.13-.057-.001-5.633-.318.083a9.2 9.2 0 0 1-2.144.249c-1.224 0-2.079-.138-3.213-.446l-.626-.17-.311-.077a5 5 0 0 0-.577-.1Z"
      />
      <path
        fill="#007BBD"
        d="M9.876 3.601c.202.023.4.058.625.109l.32.079.626.17c1.099.3 1.928.433 3.114.433q1.41 0 2.716-.423c.047-.018.1.007.117.055l.005.015v6.208a.1.1 0 0 1-.06.091l-.3.133q-1.44.607-2.478.605c-.859 0-1.39-.097-2.3-.393l-.817-.273a8 8 0 0 0-1.403-.343l-.205-.027q-.75-.085-1.982-.05l-.449.015-.002-6.239L7.4 3.57a.01.01 0 0 1 .01-.01l.136-.004q1.512-.047 2.33.045"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Corner;
